<template>
  <v-autocomplete
    v-model="selectedModelList"
    :items="modelList"
    clearable
    hide-no-data
    hide-selected
    return-object
    :loading="loading"
    item-value="id"
    item-text="title"
    label="Поиск статусы"
    persistent-hint
    @change="onSelectedModelListChange"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import OfficeListFilterMixin from '@/mixins/offerEditMixin'

export default {
  name: 'WBDStatusSelectorFilter',
  mixins: [OfficeListFilterMixin],
  props: {
    filteredLaborerList: {
      type: String,
    },
    remoteList: {
      type: Array,
    },
  },
  data () {
    return {
      loading: false,
      searchQuery: null,
      modelList: [
        {
          id: 'active',
          title: 'Активные',
        },
        {
          id: 'draft',
          title: 'Неактивные',
        },
      ],
      selectedModelList: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
    getModelList () {
      return this.modelList
    },
  },
  created () {
    if (this.remoteList && this.remoteList.length) {
      this.modelList = this.remoteList
      this.selectedModelList = this.remoteList[0]
    }
    this.eventsBus.$on(this.eventNames.OFFICE_STATUS_LIST_FILTER_RESET, () => {
      this.selectedModelList = null
      this.searchQuery = null
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    onSelectedModelListChange () {
      this.$emit(
        'onOfficeStatusSelectorFilterChange',
        this.selectedModelList ? this.selectedModelList.id : null
      )
    },
  }
}
</script>
